// Gates the surveys overhaul: the "Questionários" tab on the user profile
// (responses grouped per survey form, who each response is for and who
// filled it, single-response and history prints) and the survey builder.
// Seed migration: amsm-backend
// hall/feature_flags/migrations/0013_seed_survey_management_flag.py
export const SURVEY_MANAGEMENT_FLAG = 'survey_management'
